<svg
    [attr.aria-hidden]="ariaHidden()"
    [attr.aria-label]="ariaLabel()"
    [attr.role]="role()"
    [attr.focusable]="false"
    [attr.nopin]="'nopin'"
    [attr.width]="width()"
    [attr.height]="height()"
    [attr.fill]="fill()"
    [attr.stroke]="stroke()"
    [attr.viewBox]="viewBox()"
    [attr.preserveAspectRatio]="'none'"
    [attr.data-test-id]="testId()">
    <use attr.href="#ng__{{ name() }}"></use>
</svg>
